module.exports = __webpack_public_path__ + "assets/img/help_image01-1@2x.50b3ab48.png";